/**
 * 总后台按钮权限：每个具体操作独立编码，如 users:export
 * 未分配权限的按钮不显示（严格模式，无默认放行）
 */

export function hasPerm(codes, code) {
  if (!code) return false
  if (!codes || !codes.length) return false
  return codes.includes(code)
}

export function isUsersViewOnly(codes) {
  return !hasPerm(codes, 'users:viewSensitive')
}

function applyAuthEl(el, codes, value) {
  if (!value) return
  const allowed = hasPerm(codes, value)
  if (!allowed) {
    el.style.display = 'none'
  } else {
    el.style.display = ''
  }
}

export default function installPermission(app, store) {
  const getCodes = () => store.state.buttonCodes || []

  app.config.globalProperties.$perm = (code) => hasPerm(getCodes(), code)

  app.config.globalProperties.$usersViewOnly = () =>
    isUsersViewOnly(getCodes())

  app.directive('auth', {
    mounted(el, binding) {
      applyAuthEl(el, getCodes(), binding.value)
    },
    updated(el, binding) {
      applyAuthEl(el, getCodes(), binding.value)
    },
  })
}
